(function () {
  // Ensure the `window.theme` namespace exists
  window.theme = window.theme || {};

  // Initialize Bootstrap tooltips and popovers if Bootstrap is loaded
  if (window.bootstrap) {
    // Initialize Bootstrap tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
      new window.bootstrap.Tooltip(el);
    });

    // Initialize Bootstrap popovers
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
      new window.bootstrap.Popover(el);
    });
  } else {
    console.warn(
      "Bootstrap is not loaded. Tooltips and popovers will not be initialized."
    );
  }

  // Debounce function
  window.theme.debounce = function (callback, wait = 200) {
    let timeout;
    return (...args) => {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => callback.apply(context, args), wait);
    };
  };

  // Throttle function
  window.theme.throttle = function (callback, timeFrame = 200) {
    let lastTime = 0;
    return function () {
      const now = Date.now();
      if (now - lastTime >= timeFrame) {
        callback();
        lastTime = now;
      }
    };
  };

  // Create cookie function
  window.theme.createCookie = function (name, value, days) {
    let date, expires;
    if (days) {
      date = new Date();
      date.setDate(date.getDate() + days);
      expires = "; expires=" + date.toUTCString();
    } else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  };

  // Manage header transparency based on scroll
  const header = document.querySelector(".header");
  if (header) {
    header.classList.remove("sticky");
  } else {
    console.warn("Header element not found. Cannot remove 'sticky' class.");
  }

  // Calculate "xx time ago" with localization
  window.theme.calcTimeAgo = function (timestamp) {
    const now = new Date().getTime();
    const diff = now - timestamp;

    let text;

    // Ensure localization exists
    const locales =
      window.theme.locales && window.theme.locales.times
        ? window.theme.locales.times
        : {
            moments: "a moment ago",
            minute: "minute",
            minutes: "minutes",
            hour: "hour",
            hours: "hours",
            day: "day",
            days: "days",
            ago: "ago",
          };

    if (diff < 60000) {
      text = locales.moments;
    } else if (diff < 3.6e6) {
      const min = Math.round(diff / 60000);
      text =
        min === 1 ? `${min} ${locales.minute}` : `${min} ${locales.minutes}`;
    } else if (diff < 8.64e7) {
      const hours = Math.round(diff / 3.6e6);
      text =
        hours === 1 ? `${hours} ${locales.hour}` : `${hours} ${locales.hours}`;
    } else {
      const days = Math.round(diff / 8.64e7);
      text = days === 1 ? `${days} ${locales.day}` : `${days} ${locales.days}`;
    }

    return `${text} ${locales.ago}`;
  };

  // Format money using Shopify's format
  window.Shopify = window.Shopify || {};
  window.Shopify.formatMoney = function (
    cents,
    moneyFormat = window.Shopify.moneyFormat || "{{amount}}"
  ) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultOption(opt, def) {
      return typeof opt === "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    const match = moneyFormat.match(placeholderRegex);
    if (match && match[1]) {
      switch (match[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
    } else {
      console.warn(
        "Money format placeholder not found. Using default formatting."
      );
      value = formatWithDelimiters(cents, 2);
    }

    return moneyFormat.replace(placeholderRegex, value);
  };

  // Resize images using Shopify's resizeImage function
  window.Shopify.resizeImage = function (src, size, crop = "") {
    if (typeof src !== "string") {
      console.warn("Invalid source provided to resizeImage.");
      return src;
    }

    return src
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
        "."
      )
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
          crop = `_crop_${crop}`;
        }
        return `_${size}${crop}${match}`;
      });
  };

  // Initialize Shopify's challenge page button
  const challengeButton = document.querySelector(
    ".btn.shopify-challenge__button"
  );
  if (challengeButton) {
    challengeButton.classList.add("btn-primary");
  } else {
    console.warn(
      "Shopify challenge button not found. Cannot add 'btn-primary' class."
    );
  }

  // Style Shopify's error messages
  const errors = document.querySelector(".errors");
  if (errors) {
    errors.classList.add("alert", "alert-danger");
  } else {
    console.warn("Errors container not found. Skipping error styling.");
  }

  // Wrap Shopify's section apps within a container
  document
    .querySelectorAll(".shopify-section > .shopify-app-block")
    .forEach((elem) => {
      elem.classList.add("container");
    });

  // Detect viewport with the Intersection Observer API
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("viewport-entered");
          } else {
            entry.target.classList.remove("viewport-entered");
          }
        });
      },
      { threshold: 0.4 }
    );

    const viewportElements = document.querySelectorAll(".viewport-detect");
    if (viewportElements.length > 0) {
      viewportElements.forEach((el) => observer.observe(el));
    } else {
      console.warn(
        "No elements with class 'viewport-detect' found for Intersection Observer."
      );
    }
  } else {
    console.warn("IntersectionObserver is not supported in this browser.");
  }

  // Swiper Slider Custom Element
  if (window.Swiper) {
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        this.init();

        // Listen for Shopify section load events to reinitialize Swiper
        document.addEventListener("shopify:section:load", (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        });
      }

      init() {
        const swiperElement = this.querySelector(".swiper");
        if (swiperElement) {
          this.slider = new window.Swiper(swiperElement, {
            speed: this.speed,
            autoplay: this.autoplay,
            navigation: this.navigation.enabled
              ? {
                  prevEl: ".swiper-button-prev",
                  nextEl: ".swiper-button-next",
                }
              : false,
            pagination: this.pagination.enabled
              ? {
                  el: ".swiper-pagination",
                  type: "bullets",
                  dynamicBullets: true,
                  dynamicMainBullets: 2,
                  renderFraction: function (currentClass, totalClass) {
                    return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
                  },
                }
              : false,
            scrollbar: this.scrollbar.enabled
              ? {
                  el: ".swiper-scrollbar",
                  draggable: true,
                }
              : false,
            breakpoints: this.breakpoints,
            rewind: true,
          });
        } else {
          console.warn(
            "Swiper element not found within SwiperSlider component."
          );
        }
      }

      // Retrieve dataset attributes safely
      get speed() {
        const speed = Number(this.dataset.sliderSpeed);
        return isNaN(speed) ? 300 : speed; // Default speed
      }

      get autoplay() {
        const autoplayDelay = Number(this.dataset.sliderAutoplay);
        return this.dataset.sliderAutoplay === "0" || isNaN(autoplayDelay)
          ? false
          : { delay: autoplayDelay * 1000 };
      }

      get navigation() {
        return {
          enabled: this.dataset.sliderNavigation === "true",
        };
      }

      get pagination() {
        return {
          enabled: this.dataset.sliderPagination === "true",
        };
      }

      get scrollbar() {
        return {
          enabled: this.dataset.sliderScrollbar === "true",
        };
      }

      get breakpoints() {
        return {
          0: { slidesPerView: Number(this.dataset.breakpointMobile) || 1 },
          600: { slidesPerView: Number(this.dataset.breakpointTablet) || 2 },
          1200: { slidesPerView: Number(this.dataset.breakpointDesktop) || 3 },
        };
      }
    }

    customElements.define("swiper-slider", SwiperSlider);
  } else {
    console.warn(
      "Swiper library is not loaded. SwiperSlider components will not function."
    );
  }

  // Accordion Icon Rotation
  document.addEventListener("DOMContentLoaded", function () {
    const accordionButtons = document.querySelectorAll(
      "#faq-accordion-location-faq .accordion-button"
    );

    accordionButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const icon = this.querySelector("i");
        // Toggle the 'fa-plus' and 'fa-minus' classes
        if (this.classList.contains("collapsed")) {
          icon.classList.remove("fa-minus");
          icon.classList.add("fa-plus");
        } else {
          icon.classList.remove("fa-plus");
          icon.classList.add("fa-minus");
        }
      });
    });
  });

  // Localization form handling
  document
    .querySelectorAll(".shopify-localization-form button")
    .forEach((btn) => {
      const form = btn.closest("form");
      if (form && btn.dataset.isoCode) {
        btn.addEventListener("click", () => {
          const countryInput = form.querySelector('[name="country_code"]');
          if (countryInput) {
            countryInput.value = btn.dataset.isoCode;
            form.submit();
          } else {
            console.warn("Country code input not found in localization form.");
          }
        });
      } else {
        console.warn(
          "Localization form or ISO code data attribute missing on button."
        );
      }
    });
})();


// Product Gallery and Variant Selection Handler
class ProductForm {
  constructor() {
    this.selectors = {
      productForm: 'product-form',
      optionSelect: '[data-option-select]',
      galleryContainer: '[data-gallery-container]',
      variantMedia: '[data-variant-media]',
      addToCartButton: '[data-add-to-cart]',
      priceContainer: '[data-price-container]',
      mainCarousel: '.main-carousel',
      thumbnailCarousel: '.thumbnail-carousel'
    };
    this.init();
  }

  init() {
    this.productForms = document.querySelectorAll(this.selectors.productForm);
    if (!this.productForms.length) return;
    this.productForms.forEach(form => {
      this.initializeForm(form);
    });
  }

  initializeForm(form) {
    const variantJson = form.querySelector('[data-variants]')?.dataset?.variants;
    if (!variantJson) return;
    this.variants = JSON.parse(variantJson);
    this.optionSelects = form.querySelectorAll(this.selectors.optionSelect);
    this.gallery = form.closest('.product-contents').querySelector(this.selectors.galleryContainer);
    
    // Initialize Flickity with a slight delay to ensure proper rendering
    setTimeout(() => {
      this.initFlickity();
    }, 100);
    
    // Add change event listeners to option selects
    this.optionSelects.forEach(select => {
      select.addEventListener('change', this.onOptionChange.bind(this));
    });

    // Initial variant selection
    const initialOptions = this.getCurrentOptions(form);
    const initialVariant = this.findVariant(initialOptions);
    if (initialVariant) {
      this.updateProductMedia(initialVariant);
    }
  }

  initFlickity() {
    if (!this.gallery) return;

    // Destroy existing instances if they exist
    if (this.flktyMain) this.flktyMain.destroy();
    if (this.flktyThumbs) this.flktyThumbs.destroy();

    // Initialize main carousel
    const mainCarousel = this.gallery.querySelector(this.selectors.mainCarousel);
    this.flktyMain = new Flickity(mainCarousel, {
      cellSelector: '.carousel-cell',
      prevNextButtons: true,
      pageDots: false,
      adaptiveHeight: true, // Set to false for consistent height
      wrapAround: false,
      accessibility: true,
      setGallerySize: true
    });

    // Initialize thumbnail carousel
    const thumbnailCarousel = this.gallery.querySelector(this.selectors.thumbnailCarousel);
    if (thumbnailCarousel) {
      this.flktyThumbs = new Flickity(thumbnailCarousel, {
        cellSelector: '.carousel-cell',
        asNavFor: mainCarousel,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: true
      });
    }

    // Resize after initialization to ensure proper layout
    this.flktyMain.resize();
    if (this.flktyThumbs) this.flktyThumbs.resize();
  }

  onOptionChange(event) {
    const form = event.target.closest('form');
    const selectedOptions = this.getCurrentOptions(form);
    const variant = this.findVariant(selectedOptions);
    if (variant) {
      this.updateVariantInput(form, variant);
      this.updateProductMedia(variant);
      this.updateURL(variant);
      this.updatePrice(form, variant);
    }
  }

  getCurrentOptions(form) {
    const options = [];
    form.querySelectorAll(this.selectors.optionSelect).forEach(select => {
      options.push(select.value);
    });
    return options;
  }

  findVariant(selectedOptions) {
    return this.variants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });
  }

  updateVariantInput(form, variant) {
    const input = form.querySelector('input[name="id"]');
    if (input) input.value = variant.id;
  }

  updateProductMedia(variant) {
    if (!variant || !this.gallery || !this.flktyMain) return;

    // Find the appropriate slide for the variant
    const slides = this.gallery.querySelectorAll('[data-media-id]');
    let slideIndex = -1;

    slides.forEach((slide, index) => {
      const variantIds = slide.dataset.variantIds;
      if (variantIds) {
        const ids = variantIds.split(',').map(id => id.trim());
        if (ids.includes(variant.id.toString())) {
          slideIndex = index;
        }
      } else if (variant.featured_media && slide.dataset.mediaId === variant.featured_media.id.toString()) {
        slideIndex = index;
      }
    });

    // If we found a matching slide, select it
    if (slideIndex >= 0) {
      // Use requestAnimationFrame for smooth transition
      requestAnimationFrame(() => {
        this.flktyMain.select(slideIndex, false, true);
        if (this.flktyThumbs) {
          this.flktyThumbs.select(slideIndex, false, true);
        }
      });
    }

    // Resize Flickity to ensure proper layout
    setTimeout(() => {
      this.flktyMain.resize();
      if (this.flktyThumbs) {
        this.flktyThumbs.resize();
      }
    }, 100);
  }

  updateURL(variant) {
    if (!variant) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  updatePrice(form, variant) {
    const priceContainer = form.querySelector(this.selectors.priceContainer);
    if (!priceContainer || !variant) return;
    const regularPrice = priceContainer.querySelector('[data-regular-price]');
    const comparePrice = priceContainer.querySelector('[data-compare-price]');
    if (regularPrice) {
      regularPrice.innerHTML = this.formatMoney(variant.price);
    }
    if (comparePrice) {
      if (variant.compare_at_price > variant.price) {
        comparePrice.innerHTML = this.formatMoney(variant.compare_at_price);
        comparePrice.style.display = 'block';
      } else {
        comparePrice.style.display = 'none';
      }
    }
  }

  formatMoney(cents) {
    return (cents / 100).toFixed(2);
  }
}

// Initialize on document load
document.addEventListener('DOMContentLoaded', () => {
  new ProductForm();
});